import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AuthConfig, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { InitialAuthService } from './initial-auth.service';
import { environment } from '../../../../environments/environment';
import { SharedServiceToken } from '../../services/store/token-store/shared-storage.service-token';
import { CookiesStorageService } from 'ngx-store';

const configAuthZero: AuthConfig = {
  issuer: `${environment.issuer}`,
  redirectUri: `${environment.redirectUri}`,
  clientId: `${environment.clientId}`,
  scope: `${environment.scope}`,
  responseType: 'code',
  requireHttps: environment.requireHttps,
  postLogoutRedirectUri: `${environment.postLogoutRedirectUri}`,
};
/*configAuthZero.logoutUrl =
  `${configAuthZero.issuer}v2/logout?client_id=${configAuthZero.clientId}&returnTo=${encodeURIComponent(configAuthZero.redirectUri)}`;*/

@NgModule({
  imports: [
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: environment.allowedUrls,
        sendAccessToken: true,
      },
    }),
  ],
  providers: [
    InitialAuthService,
    CookiesStorageService,
    { provide: AuthConfig, useValue: configAuthZero },
    { provide: OAuthStorage, useClass: SharedServiceToken },
    {
      provide: APP_INITIALIZER,
      useFactory: (initialAuthService: InitialAuthService) => () => initialAuthService.initAuth(),
      deps: [InitialAuthService],
      multi: true,
    },
  ],
})
export class AuthModule {}
